<section id="home" class="section welcome-area bg-overlay bg-overlay-color1-step6 overflow-hidden d-flex align-items-center" style="padding-top: 100px; height: 500px; z-index: 1;">
    <div class="container">
        <div class="row justify-content-center align-items-center">
            <!-- Welcome Intro Start -->
            <div class="col-12 col-md-10">
                <div class="welcome-intro text-center mt-0 py-5">
                    <h1 class="text-white" style="font-size: 3.3rem">Here is our list of services available</h1>
                    <!-- <p class="text-white my-4"></p> -->
                    <!-- Buttons -->
                    <!-- <div class="button-group">
                        <a href="#" class="btn btn-bordered-white">Contact Us</a>
                        <a href="#" class="btn btn-bordered-white d-none d-sm-inline-block">View Process</a>
                    </div> -->
                </div>
            </div>
        </div>
    </div>
    
    <!-- Shape Bottom -->
    <div class="welcome-shape">
        <img src="assets/img/hero_shape.png" alt="">
    </div>
</section>

    <!-- SERVICES SECTION -->
<section id="service" class="section service-area bg-white ptb_150">
    <div class="container">
        <!-- <div class="row">
            <div class="col-12">
                <h3>We're building up our service list, if you don't see something listed don't hesistate to call and we can investigate and potentially add this service</h3>
            </div>
        </div> -->
        <div class="row">
            <div class="col-12 col-md-6 col-lg-4" *ngFor="let service of serviceList">
                <div class="single-service service-gallery overflow-hidden">
                    <div class="service-thumb">
                        <a  *ngIf='service.hideBlogPost === undefined; else hiddenBlogPost' [routerLink]="'post/'+service.link"><img src="{{service.image}}" alt=""></a>
                        <ng-template #hiddenBlogPost>
                            <img src="{{service.image}}" alt="">
                        </ng-template>
                    </div>
                    <div class="service-content bg-white">
                        <a>
                            <h3>{{service.title}}</h3>
                        </a>
                        <p class="py-3">{{service.message}}</p>
                        <a *ngIf='service.hideBlogPost === undefined' class="service-btn" [routerLink]="'post/'+service.link">Learn More</a>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <div class="shape shape-bottom">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 1000 100" preserveAspectRatio="none" fill="#f5f5f4">
            <path class="shape-fill" d="M421.9,6.5c22.6-2.5,51.5,0.4,75.5,5.3c23.6,4.9,70.9,23.5,100.5,35.7c75.8,32.2,133.7,44.5,192.6,49.7
c23.6,2.1,48.7,3.5,103.4-2.5c54.7-6,106.2-25.6,106.2-25.6V0H0v30.3c0,0,72,32.6,158.4,30.5c39.2-0.7,92.8-6.7,134-22.4
c21.2-8.1,52.2-18.2,79.7-24.2C399.3,7.9,411.6,7.5,421.9,6.5z"></path>
        </svg>
    </div>
</section>

<section id="contact" class="contact-area bg-grey ptb_100">
    <app-contact-form></app-contact-form>
</section>
